<script setup>
import {inject, onBeforeMount, ref} from "vue";
import axios from "axios";
import {useForm, usePage} from "@inertiajs/vue3";
import FormInput from '@/components/Shared/Form/Input/Index';
import FormButton from '@/components/Shared/Form/Button';

const trans = inject('trans');

const partner = ref({});
const parentSignedContract = ref({});
const isLoading = ref(true);
const page = usePage();
const partnerObject = ref({});

const submit = () => {
  form.post(route('partner.partners.update', {"partner": partner.value.id}));
};

const form = useForm({
  commission_on_mrr: 0,
  commission_on_consultancy: 0,
});

onBeforeMount(async () => {
  await axios.get(route('partner.partners.fetch', {'partner': page.props.ziggy.params.partner})).then(({ data }) => {
    partner.value = data.partner;
    let parentSignedContractData = data.parentSignedContract
    let partnerSignedContractData = data.partnerSignedContract

    form.commission_on_mrr = partnerSignedContractData.commission_on_mrr
    form.commission_on_consultancy = partnerSignedContractData.commission_on_consultancy

    parentSignedContractData.commission_on_mrr = parentSignedContractData.commission_on_mrr ?? 0
    parentSignedContractData.commission_on_consultancy = parentSignedContractData.commission_on_consultancy ?? 0
    parentSignedContract.value = parentSignedContractData

    partnerObject.value.name = partner.value.company_name;

    isLoading.value = false
  });
})

</script>

<template>
  <div class="partners">
    <div class="tile mt-4 pb-4 mb-8">
      <loading-view :loading="isLoading" class="mx-6">
          <div class="form_justify_left">
            <h1 class="h4">{{ trans('dashboard.partner.partners.title', partnerObject) }}</h1>
            <form role="form" class="pt-2" @submit.prevent="submit">
              <form-input
                v-model="form.commission_on_mrr"
                type="number"
                id="commission-mrr"
                name="commission_mrr"
                :label-text="trans('dashboard.partner.partners.commission_on_mrr_max_percentage', {percentage: parentSignedContract.commission_on_mrr})"
                :placeholder="trans('dashboard.partner.partners.commission_on_mrr')"
                container-class="form_group"
                :error="form.errors.commission_on_mrr"
                min="0"
                :max="parentSignedContract.commission_on_mrr ?? 0"
              />

              <form-input
                v-model="form.commission_on_consultancy"
                type="number"
                id="user-first-name"
                name="commission_consultancy"
                :label-text="trans('dashboard.partner.partners.commission_on_consultancy_max_percentage', {percentage: parentSignedContract.commission_on_consultancy})"
                :placeholder="trans('dashboard.partner.partners.commission_on_consultancy')"
                container-class="form_group"
                :error="form.errors.commission_on_consultancy"
                min="0"
                :max="parentSignedContract.commission_on_consultancy"
              />

              <div class="form_row pt-2">
                <span></span>
                <div>
                  <inertia-link
                    :href="$route('dashboard.partner.partners.show')"
                    class="button button_cancel"
                    :disabled="form.processing"
                  >
                    <span>{{ trans('common.Cancel') }}</span>
                  </inertia-link>

                  <form-button :value="trans('common.Save')" :processing="form.processing"/>
                </div>
              </div>
            </form>
          </div>
      </loading-view>
    </div>
  </div>
</template>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue';

export default {
  layout: DashboardLayout,
};
</script>